const urls = {
  loginUrl: 'https://api.aniplustv.com:3060/login',
  apiUrl: 'https://api.aniplustv.com:3060',
  apiUrl2: 'https://api.aniplustv.com:3100',
  imgUrl: 'https://0i3z252hh7.ecn.cdn.ofs.kr',
  imgUrlTvee: 'https://ah9szoaj9w.ecn.cdn.ofs.kr',
  fileUrl: 'https://bc8azosk4j.ecn.cdn.ofs.kr/aniplustv',

  goodsImgUrl: 'https://ah9szoaj9w.ecn.cdn.ofs.kr/images/tvee-admin/shopping/',
  stilImgUrl: 'https://ah9szoaj9w.ecn.cdn.ofs.kr/images/shop/still/',
  bannerImgUrl: 'https://bc8azosk4j.ecn.cdn.ofs.kr/TShop/banner/',
  groupImgUrl: 'https://bc8azosk4j.ecn.cdn.ofs.kr/TShop/group/',

  profileImgUrl: 'https://bc8azosk4j.ecn.cdn.ofs.kr/aniplustv/characterImg/',
  exhibitionImgUrl: 'https://bc8azosk4j.ecn.cdn.ofs.kr/TShop/content/',

  qnaFileUrl: 'https://bc8azosk4j.ecn.cdn.ofs.kr/TShop/qna/',
  refundFileUrl: 'https://api.aniplustv.com:3060/refund',
};

export const {
  loginUrl,
  apiUrl,
  apiUrl2,
  imgUrl,
  imgUrlTvee,
  fileUrl,
  goodsImgUrl,
  stilImgUrl,
  bannerImgUrl,
  groupImgUrl,
  profileImgUrl,
  exhibitionImgUrl,
  qnaFileUrl,
  refundFileUrl,
} = urls;
